class stringConstantsClass
{
    // Notification Feature Constants
    public NOTIFICATION_TABLE_NAME:string = "fyiNotifications";
    public NOTIFICATION_DELETE_TEXT:string = "delete";

    // Stage Management Constants
    public NEW_ENTITY_CREATION:string = "New entity created.";
    public UPDATE_ENTITY:string = "Entity updated.";
    public STATE_MANAGER_NODE:string = "stateManager";
    public REASSIGN_ACTION_TEXT:string = "reassign";
    public ROLLBACK_ACTION_TEXT:string = "rollback";

    // Webhook specific constants
    public WEBHOOKLOG_TABLE_NAME:string = "webhookLog";

    // Text based constants - Function
    public AAD_TEXT:string = "aad";
    public METADATA:string = "metadata";
}

export const stringConstants = new stringConstantsClass();